import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BadgeService {
  private readonly navigator: any;

  constructor(private platform: Platform) {
    this.navigator = window.navigator;
  }

  /**
   * Проверяет поддержку Badging API
   */
  private isBadgingSupported(): boolean {
    return this.platform.isBrowser && 'setAppBadge' in this.navigator && 'clearAppBadge' in this.navigator;
  }

  /**
   * Устанавливает количество уведомлений на иконке
   * @param count количество уведомлений
   */
  async setBadgeCount(count: number): Promise<void> {
    if (!this.isBadgingSupported()) {
      return;
    }

    try {
      if (count > 0) {
        await this.navigator.setAppBadge(count);
      } else {
        await this.navigator.clearAppBadge();
      }
    } catch (error) {
      console.error('Ошибка при установке бейджа:', error);
    }
  }

  /**
   * Очищает бейдж с иконки
   */
  async clearBadge(): Promise<void> {
    if (this.isBadgingSupported()) {
      try {
        await this.navigator.clearAppBadge();
      } catch (error) {
        console.error('Ошибка при очистке бейджа:', error);
      }
    }
  }
}
